// About
import Hashtags from "../components/Hashtags";
import {ReactComponent as Lightbulb} from "../media/graphics/lightbulb.svg";
import {ReactComponent as SmallMouse} from "../media/graphics/small-mouse.svg";

function About() {
	return (
		<main className="about page">
			<section className="about-intro section-wrapper intro">
				<div>
					<h1>About</h1>
					<p>I'm a Front-End Web Developer and a Web Designer.</p>
					<Hashtags />
				</div>
				<Lightbulb className="lightbulb"/>
			</section>

			<section className="about-content section-wrapper">
				<article className="about-story">
					<h2 className="section-type">Story</h2>
					<p>I have long been interested in computer and coding.  My background of studying Electrical Engineering really helped me to accomplish creating interactive websites, not only for the appearance of the websites, but also for complex functionality that involves more in depth programming concepts.</p>
					<p>I love designing as well. I didn't realize soon that I want to work it as a job instead of an interest only. That's how I started off with web developing.</p>
					<p>There aren't many jobs that allow people to do problem solving through the strength of coding and creating their world through the designing at the same time.</p>
					<p>I believe that there is a great world waiting to be explored. And I would be more than willing to go on this long journey.</p>
				</article>

				<article className="about-skills">
					<h2 className="section-type">Skills</h2>
					<div className="skill-lists">
						<div>
							<h3>Development</h3>
							<ul>
								<li>HTML</li>
								<li>CSS</li>
								<li>JavaScript</li>
								<li>jQuery</li>
								<li>WordPress</li>
								<li>React</li>
								<li>PHP</li>
							</ul>
						</div>
						
						<div>
							<h3>Design</h3>
							<ul>
								<li>Adobe XD</li>
								<li>InVision</li>
								<li>Figma</li>
								<li>Adobe Photoshop</li>
								<li>Adobe Illustrator</li>
								<li>Adobe Premiere Pro</li>
							</ul>
						</div>
						
					</div>
					
					<SmallMouse className="small-mouse"/>
				</article>
			</section>
		</main>

	)
	
}

export default About;
